// src/api/billing.js
// Billing API helpers — Stripe checkout session creation and billing status.

import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

/**
 * Create a Stripe Checkout session for the given tier upgrade.
 * @param {Object} params
 * @param {string} params.tier - "advanced" | "pro" | "executive"
 * @param {string} [params.interval] - "monthly" | "annual" | "yearly"
 * @param {string} [params.customerEmail] - Pre-fill the Stripe Checkout email field
 * @returns {Promise<{url: string, session_id: string}>}
 */
export const createCheckoutSession = async ({ tier, interval = "monthly", customerEmail } = {}) => {
  const body = {
    tier,
    interval,
    success_url: `${window.location.origin}/settings?billing=success`,
    cancel_url: `${window.location.origin}${window.location.pathname}?billing=cancelled`,
  };
  if (customerEmail) body.customer_email = customerEmail;
  const response = await axios.post(`${API_BASE_URL}/billing/create-checkout-session`, body);
  return response.data;
};

/**
 * Fetch the current persisted billing state.
 * @returns {Promise<{status: string, customer_id: string|null, tier: string, subscription_status: string}>}
 */
export const getBillingStatus = async () => {
  const response = await axios.get(`${API_BASE_URL}/billing/status`);
  return response.data;
};

/**
 * Create a Stripe Customer Portal session for subscription management.
 * @param {Object} params
 * @param {string} params.customerId - Stripe customer ID (cus_...)
 * @returns {Promise<{url: string}>}
 */
export const createPortalSession = async ({ customerId } = {}) => {
  const response = await axios.post(`${API_BASE_URL}/billing/portal`, {
    customer_id: customerId,
    return_url: `${window.location.origin}/settings`,
  });
  return response.data;
};
